<template>
    <div class="container">
        <el-scrollbar wrap-class="scrollbar-wrapper">
            <el-menu :default-active="$route.path" :unique-opened="true" background-color="#001529" text-color="#fff" :collapse-transition="false" active-text-color="rgb(166, 59, 58)" :router="true">
                <template v-for="item in menuList">
                    <template v-if="!item.childMenu">
                        <el-menu-item :index="item.accessUrl" :route="item.accessUrl" :key="item.id">
                            <span slot="title">{{ item.name }}</span>
                        </el-menu-item>
                    </template>
                    <template v-else>
                        <el-submenu :index="item.id + ''" :key="item.id">
                            <template slot="title">
                                <span slot="title">{{ item.name }}</span>
                            </template>
                            <template v-for="i in item.childMenu">
                                <el-menu-item :index="i.accessUrl" :route="i.accessUrl" :key="i.id">{{ i.name }}</el-menu-item>
                            </template>
                        </el-submenu>
                    </template>
                </template>
            </el-menu>
        </el-scrollbar>
    </div>
</template>
<script>
    import { getUserInfo } from "@/api/request";
    export default {
        data() {
            return {
                menuList: [
                    {
                        code: "000M0j",
                        accessUrl: "branchs",
                        picType: 1,
                        name: "门店管理",
                        id: 301,
                        type: 1,
                        parentId: 0,
                        childMenu: [
                            {
                                code: "000M0k",
                                accessUrl: "/branchs",
                                picType: 1,
                                name: "门店列表",
                                id: 302,
                                type: 1,
                                parentId: 301,
                                buttonDetails: [
                                    {
                                        buttonDetails: [],
                                        code: "00d00B0100",
                                        name: "添加",
                                        id: 31,
                                        type: 2,
                                        parentId: 292,
                                    },
                                    {
                                        buttonDetails: [],
                                        code: "00d00B0200",
                                        name: "修改",
                                        id: 32,
                                        type: 2,
                                        parentId: 292,
                                    },
                                ],
                            },
                            {
                                code: "000M02",
                                accessUrl: "/workers",
                                picType: 1,
                                name: "师傅管理",
                                id: 303,
                                type: 1,
                                parentId: 301,
                                buttonDetails: [
                                    {
                                        buttonDetails: [],
                                        code: "00d00B0100",
                                        name: "添加",
                                        id: 31,
                                        type: 2,
                                        parentId: 292,
                                    },
                                    {
                                        buttonDetails: [],
                                        code: "00d00B0200",
                                        name: "修改",
                                        id: 32,
                                        type: 2,
                                        parentId: 292,
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        code: "000A01",
                        accessUrl: "/services",
                        picType: 1,
                        name: "服务管理",
                        id: 304,
                        type: 1,
                        parentId: 0,
                        childMenu: [
                            {
                                code: "000A02",
                                accessUrl: "/services",
                                picType: 1,
                                name: "服务项目",
                                id: 305,
                                type: 1,
                                parentId: 304,
                                buttonDetails: [
                                    {
                                        buttonDetails: [],
                                        code: "00d00B0100",
                                        name: "添加",
                                        id: 31,
                                        type: 2,
                                        parentId: 292,
                                    },
                                    {
                                        buttonDetails: [],
                                        code: "00d00B0200",
                                        name: "修改",
                                        id: 32,
                                        type: 2,
                                        parentId: 292,
                                    },
                                ],
                            },
                            {
                                code: "000A02",
                                accessUrl: "/banner",
                                picType: 1,
                                name: "banner管理",
                                id: 307,
                                type: 1,
                                parentId: 304,
                                buttonDetails: [
                                    {
                                        buttonDetails: [],
                                        code: "00d00B0100",
                                        name: "添加",
                                        id: 31,
                                        type: 2,
                                        parentId: 292,
                                    },
                                    {
                                        buttonDetails: [],
                                        code: "00d00B0200",
                                        name: "修改",
                                        id: 32,
                                        type: 2,
                                        parentId: 292,
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        code: "000Q01",
                        accessUrl: "/orders",
                        picType: 1,
                        name: "订单管理",
                        id: 306,
                        type: 1,
                        parentId: 0,
                        childMenu: [
                            {
                                code: "000M02",
                                accessUrl: "/orders",
                                picType: 1,
                                name: "订单列表",
                                id: 307,
                                type: 1,
                                parentId: 305,
                                buttonDetails: [
                                    {
                                        buttonDetails: [],
                                        code: "00d00B0100",
                                        name: "添加",
                                        id: 31,
                                        type: 2,
                                        parentId: 292,
                                    },
                                    {
                                        buttonDetails: [],
                                        code: "00d00B0200",
                                        name: "修改",
                                        id: 32,
                                        type: 2,
                                        parentId: 292,
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        code: "000U01",
                        accessUrl: "/users",
                        picType: 1,
                        name: "用户管理",
                        id: 406,
                        type: 1,
                        parentId: 0,
                        childMenu: [
                            {
                                code: "000U02",
                                accessUrl: "/users",
                                picType: 1,
                                name: "用户列表",
                                id: 407,
                                type: 1,
                                parentId: 305,
                                buttonDetails: [
                                    {
                                        buttonDetails: [],
                                        code: "00d00B0100",
                                        name: "添加",
                                        id: 31,
                                        type: 2,
                                        parentId: 292,
                                    },
                                    {
                                        buttonDetails: [],
                                        code: "00d00B0200",
                                        name: "修改",
                                        id: 32,
                                        type: 2,
                                        parentId: 292,
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        code: "000W01",
                        accessUrl: "/Withdrawal",
                        picType: 1,
                        name: "积分管理",
                        id: 506,
                        type: 1,
                        parentId: 0,
                        childMenu: [
                            {
                                code: "000W02",
                                accessUrl: "/Withdrawal",
                                picType: 1,
                                name: "积分列表",
                                id: 507,
                                type: 1,
                                parentId: 305,
                                buttonDetails: [
                                    {
                                        buttonDetails: [],
                                        code: "00d00B0100",
                                        name: "添加",
                                        id: 31,
                                        type: 2,
                                        parentId: 292,
                                    },
                                    {
                                        buttonDetails: [],
                                        code: "00d00B0200",
                                        name: "修改",
                                        id: 32,
                                        type: 2,
                                        parentId: 292,
                                    },
                                ],
                            },
                            {
                                code: "000W03",
                                accessUrl: "/WithdrawalInfo",
                                picType: 1,
                                name: "积分说明",
                                id: 507,
                                type: 1,
                                parentId: 305,
                                buttonDetails: [
                                    {
                                        buttonDetails: [],
                                        code: "00d00B0100",
                                        name: "添加",
                                        id: 31,
                                        type: 2,
                                        parentId: 292,
                                    },
                                    {
                                        buttonDetails: [],
                                        code: "00d00B0200",
                                        name: "修改",
                                        id: 32,
                                        type: 2,
                                        parentId: 292,
                                    },
                                ],
                            },
                        ],
                    },
                ],
            };
        },
        created() {
            this.$emit("menuLoadCallback");
            this.getInfo();
        },
        computed: {},
        methods: {
            getInfo() {
                getUserInfo().then((res) => {
                    if(res.data.id!==1){
                        this.menuList = [
                            {
                                code: "000M0j",
                                accessUrl: "branchs",
                                picType: 1,
                                name: "门店管理",
                                id: 301,
                                type: 1,
                                parentId: 0,
                                childMenu: [
                                    {
                                        code: "000M02",
                                        accessUrl: "/workers",
                                        picType: 1,
                                        name: "师傅管理",
                                        id: 303,
                                        type: 1,
                                        parentId: 301,
                                        buttonDetails: [
                                            {
                                                buttonDetails: [],
                                                code: "00d00B0100",
                                                name: "添加",
                                                id: 31,
                                                type: 2,
                                                parentId: 292,
                                            },
                                            {
                                                buttonDetails: [],
                                                code: "00d00B0200",
                                                name: "修改",
                                                id: 32,
                                                type: 2,
                                                parentId: 292,
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                code: "000Q01",
                                accessUrl: "/orders",
                                picType: 1,
                                name: "订单管理",
                                id: 306,
                                type: 1,
                                parentId: 0,
                                childMenu: [
                                    {
                                        code: "000M02",
                                        accessUrl: "/orders",
                                        picType: 1,
                                        name: "订单列表",
                                        id: 307,
                                        type: 1,
                                        parentId: 305,
                                        buttonDetails: [
                                            {
                                                buttonDetails: [],
                                                code: "00d00B0100",
                                                name: "添加",
                                                id: 31,
                                                type: 2,
                                                parentId: 292,
                                            },
                                            {
                                                buttonDetails: [],
                                                code: "00d00B0200",
                                                name: "修改",
                                                id: 32,
                                                type: 2,
                                                parentId: 292,
                                            },
                                        ],
                                    },
                                ],
                            },
                        ];
                    }
                });
            },
        },
    };
</script>
<style lang="scss" scoped>
    .container {
        width: 100%;
        background: #001529;
        height: 100%;
        overflow: hidden;
        .el-scrollbar {
            overflow: hidden;
            position: relative;
            height: 100%;
            ::v-deep .scrollbar-wrapper {
                overflow-x: hidden !important;
                margin-bottom: -18px !important;
                margin-right: -18px !important;
                .el-scrollbar__view {
                    margin-bottom: 40px;
                }
            }
            .el-menu {
                border: 0 !important;

                // 有子菜单
                .el-submenu {
                    border-bottom: 1px solid #333;
                    ::v-deep .el-submenu__title {
                        height: 46px !important;
                        line-height: 46px !important;
                    }
                    ::v-deep .el-icon-arrow-down {
                        color: #fff !important;
                        right: 25px !important;
                    }
                    ::v-deep .el-submenu__title {
                        text-align: center;
                        padding: 0 15px !important;
                        &:hover {
                            background-color: rgba(255, 255, 255, 0.1) !important;
                        }
                        .el-submenu__icon-arrow {
                            display: block;
                        }
                    }
                    .el-menu-item {
                        text-align: center;
                        height: 46px !important;
                        line-height: 46px !important;
                        padding: 0 15px !important;
                        min-width: 100%;
                        &:hover {
                            background-color: rgba(255, 255, 255, 0.1) !important;
                        }
                    }
                }
                // 无子菜单
                .el-menu-item {
                    padding: 0 20px !important;
                    &:hover {
                        background-color: rgba(255, 255, 255, 0.1) !important;
                    }
                }
            }
            .el-menu--collapse {
                .el-submenu {
                    ::v-deep .el-submenu__title {
                        line-height: 46px !important;
                        span {
                            visibility: visible;
                            width: 14px;
                            height: auto;
                            overflow: hidden;
                        }
                    }
                }
                .el-menu-item {
                    ::v-deep .el-tooltip {
                        text-align: center !important;
                    }
                    .title-collapse {
                        height: auto;
                        width: 14px;
                        visibility: visible;
                    }
                }
            }
        }
        .fold-icon {
            position: absolute;
            bottom: 0;
            width: 100%;
            text-align: center;
            color: #fff;
            font-size: 22px;
            border-top: 1px solid #ccc;
            padding: 8px 0;
            z-index: 999;
            background: rgb(0, 17, 33);
            cursor: pointer;
        }
    }
</style>
